import dayjs from 'dayjs';
import { render, unmountComponentAtNode } from 'react-dom';

import { WorkShiftReport } from './components';
import { WorkShiftReportArgs } from './interfaces';
import { generatePDF } from './utils';

export const printWorkShiftReport = async ({
  id,
  worker,
  inCashBox,
  comment,
  currency,
  deposit,
  online_deposit,
  cash,
  card,
  bonus,
  cash_on_start,
  starts,
  finished,
  t,
  clubName,
  goods,
  cashOrders,
  services,
  combos,
  printReportAllGoods,
  allGoods,
}: WorkShiftReportArgs): Promise<void> => {
  const root = document.createElement('div');

  root.style.visibility = 'hidden';
  root.style.position = 'absolute';
  root.style.top = '0';

  document.body.appendChild(root);

  await new Promise<void>((resolve) =>
    render(
      <WorkShiftReport
        workerFIO={worker}
        inCashBox={inCashBox}
        cash={cash}
        card={card}
        deposit={deposit}
        onlineDeposit={online_deposit}
        bonus={bonus}
        cashOnStart={cash_on_start}
        createdAt={starts}
        finishedAt={finished ?? dayjs().format('YYYY-MM-DD HH:mm:ss')}
        id={id}
        clubName={clubName}
        currency={currency}
        t={t}
        isDuplicate={!!finished}
      />,
      root,
      resolve
    )
  );

  const url = await generatePDF({
    t,
    comment,
    currency,
    goods,
    services,
    cashOrders,
    useFooter: !finished,
    combos,
    printReportAllGoods,
    allGoods,
  });

  unmountComponentAtNode(root);
  document.body.removeChild(root);

  if (!finished) {
    const hiddenFrame = document.createElement('iframe');

    await new Promise<void>((resolve) => {
      hiddenFrame.style.position = 'fixed';
      hiddenFrame.style.width = '1px';
      hiddenFrame.style.height = '1px';
      hiddenFrame.style.opacity = '0.01';

      hiddenFrame.setAttribute('src', url.toString());

      document.body.appendChild(hiddenFrame);

      hiddenFrame.addEventListener('load', () => {
        hiddenFrame.focus();
        hiddenFrame.contentWindow?.print();

        resolve();
      });

      hiddenFrame.addEventListener('blur', () => {
        document.body.removeChild(hiddenFrame);
      });
    });
  } else {
    open(url);
  }
};
